<router-outlet></router-outlet>

<!--
  Fuera del router-outlet a propósito: una llamada tiene que sonar y poder
  contestarse esté el agente en la bandeja, en reportes o en configuración.
  Dentro de una ruta, cambiar de pantalla destruiría el componente y con él la
  RTCPeerConnection.
-->
<app-call-modal></app-call-modal>
